import { useState } from 'react'

const faqs = [
  {
    q: 'How long does switching take?',
    a: 'For most businesses, onboarding takes 2–4 weeks. We handle the transition — including migrating devices, transferring documentation, and coordinating any handoff from your previous provider. Your team experiences minimal disruption.',
  },
  {
    q: 'What if my current provider owns our equipment or licenses?',
    a: "We'll audit what you have and what you own before we start. In most cases, licenses are transferable and equipment stays yours. We'll tell you upfront if there are any complications — before you sign anything.",
  },
  {
    q: 'Do we have to cancel our existing contract first?',
    a: 'Not necessarily. We can help you review your current contract and advise on timing. In some cases we can begin onboarding before your existing contract expires so there\'s zero gap in coverage.',
  },
  {
    q: 'What makes NTC different from our current provider?',
    a: "We've been doing this for 11 years. 97% of our clients have never left. We answer the phone. We fix problems before you notice them. And we're not just managing your tech — we're building AI capabilities into it. Book a 30-minute call and you'll have a clear picture of the difference within the first 10 minutes.",
  },
]

export function SwitchingFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)
  return (
    <section className="py-16 px-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-display font-extrabold text-2xl md:text-3xl uppercase text-white mb-8 text-center">
          Already have an IT provider? Switching is simpler than you think.
        </h2>
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={faq.q}
              className="rounded-lg overflow-hidden"
              style={{ backgroundColor: 'var(--bg-3)' }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full px-6 py-4 flex items-center justify-between text-left font-body font-medium text-white"
              >
                {faq.q}
                <span className="text-2xl text-cream-dim">{openIndex === i ? '−' : '+'}</span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-4">
                  <p className="font-body text-cream-dim leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
